import React, { useMemo } from 'react';

import { observer } from 'mobx-react-lite';

import {
  usePopupStore,
  useTranslation,
  TablePopUpContainer,
  useApplicationStore,
  TableConnectionPopupsWr,
  PlatformMessagesWrapper,
  PostMessageListenerMessages,
  UnderMaintenanceContainer,
  DefaultQueryParams,
  parseQuery,
  LoadingContainer,
  GameLaunchManager,
} from '@pascal/pascal-core';
import { PopUps } from '@pascal/pascal-core/table-line/t_types/enums/PopupTypes';

import { HelpPopup } from '../components/helpPopup';
import { FairnessPopup } from '../components/fairnessPopup';
import { CheckHashPopup } from '../components/checkHashPop';
import { FactoryRouter } from './factoryRouter';
import { SocketConnection } from './socketConnection';
import { gameLiveConnection } from '../services';
import { TURBO_OR_TERMINAL_GAME_ID } from '../enums/constants';
import { AppDefaultValuesEnum } from '../enums/appDefaultValues';

export const Factory = observer(({ components }) => {
  const t = useTranslation();
  const { gameIsOpen } = useApplicationStore();
  const { popupName, popupToggle } = usePopupStore();
  const { [DefaultQueryParams.GameId]: gameId, [DefaultQueryParams.BetId]: betId } = parseQuery(
    window.location.search
  );
  const isTurbo = +gameId === TURBO_OR_TERMINAL_GAME_ID;

  const popupMap = useMemo(
    () => ({
      [PopUps.Fairness]: {
        component: FairnessPopup,
        title: t('FAIRNESS'),
      },
      [PopUps.CheckHash]: {
        component: CheckHashPopup,
        title: t('CHECK'),
      },
      [PopUps.Reconnect]: {
        component: TableConnectionPopupsWr,
        title: t('RECONNECT'),
      },
      [PopUps.ConnectionError]: {
        component: TableConnectionPopupsWr,
        title: t('CONNECTION_ERROR'),
      },
      [PopUps.GameOpen]: {
        component: TableConnectionPopupsWr,
        title: t('GAME_OPEN'),
      },
      // [PopUps.MobileNavigation]: MobileNavigationPopupWr,
      [PopUps.Help]: {
        component: HelpPopup,
        title: t('HELP'),
      },
    }),
    [t]
  );

  const memoAdditionalMessagesParams = useMemo(() => {
    return [
      {
        name: PostMessageListenerMessages.UpdateBalance,
        callback: gameLiveConnection.getBalance,
      },
    ];
  }, []);

  return (
    <UnderMaintenanceContainer isTurbo={isTurbo}>
      <LoadingContainer appDefaultValuesEnum={AppDefaultValuesEnum} isNeedRtlChecker={false}>
        <PlatformMessagesWrapper additionalMessagesParams={memoAdditionalMessagesParams}>
          <GameLaunchManager
            GameContainer={<FactoryRouter components={components} />}
            SocketConnectionWr={
              <SocketConnection>
                <FactoryRouter components={components} />
              </SocketConnection>
            }
            betId={+betId}
          />
        </PlatformMessagesWrapper>
        {(popupToggle || gameIsOpen) && (
          <TablePopUpContainer popupMap={popupMap} popUpName={popupName} gameIsOpen={gameIsOpen} />
        )}
      </LoadingContainer>
    </UnderMaintenanceContainer>
  );
});
